import styled, { css } from 'styled-components';

export const Toast = styled.div(
  ({ theme }) => css`
    z-index: 999;
    position: absolute;
    width: 100%;
    bottom: 10%;
    & > div:first-child {
      margin: 0 auto;
      background-color: ${theme.colors.white};
    }
    @media screen and (orientation: landscape) {
      bottom: 5%;
    }
  `,
);
